var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import Card from '@/components/Card.vue';
import Loading from '@/components/Loading.vue';
import TwoColumnsLayout from '@/modules/main/components/layouts/TwoColumnsLayout.vue';
import UserAvatar from '@/modules/main/components/UserAvatar.vue';
import { GroupAccessStatus, GroupType, GroupSubType } from '@/dto';
import Avatar from '@/components/Avatar.vue';
import { BButton } from 'bootstrap-vue';
import { GroupsService, GroupSubscriptionsService, lazyInject, Services } from '@/services';
import RequestToJoinGroupModal from '@/modules/main/router/routes/membership/activities/RequestToJoinGroupModal.vue';
import { getPlatformInitials } from '@/utils/platforms';
import AttachmentSlider from "@/modules/main/components/attachments/AttachmentSlider.vue";
import AttachmentGallery from "@/modules/main/components/attachments/AttachmentGallery.vue";
import { textToHtml } from "@/global/helpers";
var MembershipInformation = /** @class */ (function (_super) {
    __extends(MembershipInformation, _super);
    function MembershipInformation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.galleryAttachments = [];
        _this.activeAttachment = null;
        return _this;
    }
    Object.defineProperty(MembershipInformation.prototype, "initials", {
        get: function () {
            return getPlatformInitials(this.group.platform);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "urlWithProtocol", {
        get: function () {
            if (this.group && this.group.url != null) {
                if (this.group.url.indexOf('http') !== 0 && this.group.url.indexOf('//') !== 0) {
                    return "//" + this.group.url;
                }
                return this.group.url;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "contactPerson", {
        get: function () {
            var _a, _b, _c;
            return ((_a = this.group) === null || _a === void 0 ? void 0 : _a.group_users) ? (_c = (_b = this.group) === null || _b === void 0 ? void 0 : _b.group_users[0]) === null || _c === void 0 ? void 0 : _c.user : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "hasPlatform", {
        get: function () {
            var _a;
            return (_a = this.group) === null || _a === void 0 ? void 0 : _a.platform;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "platformName", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.group) === null || _a === void 0 ? void 0 : _a.platform) === null || _b === void 0 ? void 0 : _b.name;
        },
        enumerable: false,
        configurable: true
    });
    MembershipInformation.prototype.mounted = function () {
        this.$root.$on('openAttachments', this.openAttachments);
    };
    MembershipInformation.prototype.getPlatformPicture = function (platform) {
        return platform.logo_path;
    };
    Object.defineProperty(MembershipInformation.prototype, "isOpenGroup", {
        get: function () {
            var _a;
            return ((_a = this.group) === null || _a === void 0 ? void 0 : _a.access_status) === GroupAccessStatus.OPEN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "isClosedGroup", {
        get: function () {
            var _a;
            return ((_a = this.group) === null || _a === void 0 ? void 0 : _a.access_status) === GroupAccessStatus.CLOSED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "groupAddress", {
        get: function () {
            return this.group.street_name + " " + this.group.house_number + ", " + this.group.city;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "groupHasAddress", {
        get: function () {
            return this.group.street_name && this.group.city;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "hasGroupAttachments", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.group) === null || _a === void 0 ? void 0 : _a.attachments) === null || _b === void 0 ? void 0 : _b.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "groupAttachments", {
        get: function () {
            var _a;
            return (_a = this.group) === null || _a === void 0 ? void 0 : _a.attachments;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "groupTypeName", {
        get: function () {
            return GroupType[this.group.type];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "groupSubTypeName", {
        get: function () {
            var _a;
            return GroupSubType[(_a = this.group) === null || _a === void 0 ? void 0 : _a.sub_type];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MembershipInformation.prototype, "groupDescriptionHtml", {
        get: function () {
            return textToHtml(this.group.description);
        },
        enumerable: false,
        configurable: true
    });
    MembershipInformation.prototype.onAttachmentClick = function (attachment) {
        this.$root.$emit('openAttachments', attachment, this.group);
        return attachment;
    };
    MembershipInformation.prototype.openAttachments = function (attachment, group) {
        this.activeAttachment = attachment;
        this.galleryAttachments = group === null || group === void 0 ? void 0 : group.attachments;
        this.$refs.attachmentGallery.show();
    };
    __decorate([
        lazyInject(Services.GroupsService),
        __metadata("design:type", GroupsService)
    ], MembershipInformation.prototype, "groupsService", void 0);
    __decorate([
        lazyInject(Services.GroupSubscriptionsService),
        __metadata("design:type", GroupSubscriptionsService)
    ], MembershipInformation.prototype, "groupsSubscriptionService", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], MembershipInformation.prototype, "group", void 0);
    __decorate([
        Emit('attachmentClick'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], MembershipInformation.prototype, "onAttachmentClick", null);
    MembershipInformation = __decorate([
        Component({
            components: {
                Card: Card,
                Loading: Loading,
                TwoColumnsLayout: TwoColumnsLayout,
                UserAvatar: UserAvatar,
                Avatar: Avatar,
                BButton: BButton,
                RequestToJoinGroupModal: RequestToJoinGroupModal,
                AttachmentSlider: AttachmentSlider,
                AttachmentGallery: AttachmentGallery,
            },
        })
    ], MembershipInformation);
    return MembershipInformation;
}(Vue));
export default MembershipInformation;
